import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import LinkSubPage from 'components/LinkSubPage/LinkSubPage';
import './FauxSelect.scss';

export default class FauxSelect extends Component {
  static propTypes = {
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    label: PropTypes.string,
    align: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number]),
    inline: PropTypes.bool,
    noArrow: PropTypes.bool,
    error: PropTypes.bool,
    onPageChange: PropTypes.func,
    disabled: PropTypes.bool,
    isOnSearchUnit: PropTypes.bool,
    type: PropTypes.oneOf(['', 'quick-nav', 'semseo-search']),
    reportSelectFieldClicked: PropTypes.func,
    onClick: PropTypes.func,
    removeFromTabOrder: PropTypes.bool,
    location: PropTypes.object,
  };

  static defaultProps = {
    url: '#',
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  handleClick = (event) => {
    const { url, onPageChange, onClick } = this.props;

    if (url === '#') {
      event.preventDefault();
    }

    if (onPageChange) {
      onPageChange(event);
    }

    if (onClick) {
      onClick(event);
    }
  }

  render() {
    const {
      type,
      align,
      isOnSearchUnit,
      url,
      disabled,
      inline,
      error,
      noArrow,
      label,
      reportSelectFieldClicked,
      removeFromTabOrder,
      location,
    } = this.props;

    const tabIndex = removeFromTabOrder ? -1 : 0;

    let fauxSelectInnerClassName = 'faux-select__inner ';

    if (align) {
      fauxSelectInnerClassName += `faux-select__inner--align-${align} `;
    }

    if (type) {
      fauxSelectInnerClassName += `faux-select__inner--${type} `;
    }

    const labelElement = (
      <label className={`faux-select__label ${isOnSearchUnit ? 'faux-select__label--is-on-search-unit' : ''}`}>
        { disabled ? (
          <span className="faux-select__link faux-select__link--is-disabled">
            {label}
          </span>
        ) : (
          <LinkSubPage to={url} location={location} className="faux-select__link" onClick={this.handleClick}>
            {label}
          </LinkSubPage>
        )}
      </label>
    );

    const controlClassName = `faux-select__link ${noArrow && 'no-arrow'}`;

    return (
      <div className={`faux-select ${inline ? 'faux-select--is-inline' : ''} ${error ? 'faux-select--is-error' : ''}`}>
        {label && labelElement}
        <div className={`${fauxSelectInnerClassName} faux-select__inner__${type}`} onClick={reportSelectFieldClicked}>
          { disabled ? (
            <div className={`${controlClassName} faux-select__link--is-disabled`}>
              {this.props.children}
            </div>
          ) : (
            <LinkSubPage to={url} location={location} className={controlClassName} onClick={this.handleClick} tabIndex={tabIndex}>
              {this.props.children}
            </LinkSubPage>
          )}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/FauxSelect/FauxSelect.jsx
 **/